// extracted by mini-css-extract-plugin
export default {"brandPromo":"vF-z","carousel":"wF-z"};